import { render, staticRenderFns } from "./xtwh.vue?vue&type=template&id=27a78090&scoped=true&"
import script from "./xtwh.vue?vue&type=script&lang=js&"
export * from "./xtwh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a78090",
  null
  
)

export default component.exports